// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"b5882c54","198":"3f6d051b","409":"5cbff11e","689":"e69949b2"}[chunkId] + ".chunk.js";
};